import { Injectable } from '@angular/core';
import { Http, RequestOptions, Headers, ResponseContentType } from '@angular/http';
import { environment } from '../../environments/environment';
import { Token } from '../manager/token';
import { Router } from '@angular/router';
// import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { map } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { AES, enc, PBKDF2, algo } from 'crypto-js';
import * as moment from 'moment';

@Injectable({
    providedIn: 'root'
})

export class CommonService {
  // default values to encrypt password
     TokenCls;
     ITERATION = 1000;
     SALT = enc.Base64.parse('SXZhbiBNZWR2ZWRldg==');
     KEYSIZE = 256 / 32 + 128 / 32;
     hasherAlgorythm = algo.SHA1;
     minLength = 12;
     maxLength = 20;

     powerbiURL = 'https://app.powerbi.com/view?r=eyJrIjoiYmI2OWI3YjItOTBhYi00YzZjLWFmMDktMGYwMzI3OTJmYTI4IiwidCI6ImQzOTNmNzM1LTZjYzctNGQzZC1iNzk5LWUwYzlmYjM3OWMwZSJ9'

    constructor(private http: HttpClient, private router: Router) {
        this.TokenCls = new Token(this.router);
    }

    // function for encrypt password
     encryptData(data,encryptionKey:string=null) {
      const keyAndIv = PBKDF2(enc.Utf8.parse(encryptionKey || environment.Encryptionkey), this.SALT,
          { keySize: this.KEYSIZE, iterations: this.ITERATION, hasher: this.hasherAlgorythm });
      const hexKeyAndIv = enc.Hex.stringify(keyAndIv);
      return AES.encrypt(enc.Utf16LE.parse(data), enc.Hex.parse(hexKeyAndIv.substring(0, 64)),
          { iv: enc.Hex.parse(hexKeyAndIv.substring(64, hexKeyAndIv.length)) }).toString();
  }

    GetClientList(formbody): any {
        return this.http.get(environment.ApiUrl + '/api/client-lookup/' + formbody);
    }

    getUserURILookup():any {
        return this.http.get(environment.ApiUrl + '/api/user-url-lookup')
        ////return  this.http.get(environment.ApiUrl + '/api/user-url-lookup')

        // return abc.Data

        //  Observable.create(observer => {
        //  })
    }

    GetReferenceFile(filename: any):any {
        return this.http.post(environment.FileApiUrl + '/api/approval-file-download', { Reference_File_Name: filename }, { responseType: 'blob'})
            .pipe(map(res => {
                return {
                    filename: filename,
                    data: res
                };
            }));

    }

    // For search data through input use this common function
    // use have to pass 1) Array List 2) key which you want filter 3) event
    filterListOfData(arrayList,key,searchText) {
      // console.log('matchInbox : ', searchText);
      arrayList.filter((element) => {
        var result = element[key].toUpperCase().indexOf(searchText.target.value.toUpperCase());
        if (result !== -1) {
          element.show = true;
        }
        else {
          element.show = false;
        }
        // console.log('result : ', result, element)
      })
    }

    // For restrict Input Fields special characters

    /**
     * Getting 3 parameter from input
     * @param event keypress Event
     * @param formControlName Input FormControlName
     * @param formName FormGroup FormName
    */

    checkIsSpecialCharacter(event,formControlName?,formName?){
      while (!this.restrictInputFields(event,formControlName,formName)) {
        let isSpecialCharacter = this.restrictInputFields(event,formControlName,formName)
        if (isSpecialCharacter == true || event.target.value == '') {
          break;
        }
      }
    }
    restrictInputFields(event,formControlName,formName){
      var format = /^[^ `~!@#$%^&*()+\-_=\[\]{};':"\\|,.<>\/?]+/;
      if (format.test(event.target.value)) {
        // Yay! valid
        return true;
      }
      else {
        event.target.value = event.target.value.replace(/^[ `~!@#$%^&*()+\-_=\[\]{};':"\\|,.<>\/?]/gi, '');
        // code added for replace formcontrol value
        if(formControlName!= undefined && formName != undefined){
          formName.patchValue({[`${formControlName}`]: event.target.value})
        }
        return false;
    }
  }

  // allow-only-two-digits-after-decimal-in-javascript
  formatDecimal(event){
    let val = event.target.value;
    if((val).toString().match(/\d+\.\d{2}/) != null){
     return event.target.value = (val).toString().match(/\d+\.\d{2}/)[0];
    }
   }


 //#region for formcontrol form special character
 // check special character, whitespace in notes textarea
  isSpecialCharactersForForm(formControlName?: string, formName?: any) {
    let notesValue = this.getNotesValue(formControlName, formName);

    // Continue looping until the input is valid
    while (!this.removeSpecialCharacters(notesValue, formControlName, formName)) {
      if (this.removeSpecialCharacters(notesValue, formControlName, formName) || notesValue === '') {
        formName.get('Notes').setValue(notesValue);
        break;
      }
      notesValue = this.getNotesValue(formControlName, formName); // Update notesValue for the next iteration
    }
  }

  removeSpecialCharacters(textValue: string, formControlName?: string, formName?: any): boolean {
    const format = /^[^ `~!@#$%^&*()+\-_=\[\]{};':"\\|,.<>\/?]+/;

    if (format.test(textValue)) {
      // Input is valid
      return true;
    } else {
      // Input is invalid; remove invalid characters and update Notes value
      textValue = textValue.replace(/^[ `~!@#$%^&*()+\-_=\[\]{};':"\\|,.<>\/?]/gi, '');
      formName.get(formControlName).setValue(textValue);
      return false;
    }
  }

  getNotesValue(formControlName: string, formName?: any): string {
    return formName.get(formControlName).value;
  }
//#endregion for formcontrol form special character

  // Helper function to format and compare dates
  formatAndCompareDates(fromDate: any, toDate: any): { validFromDate: boolean, validToDate: boolean } {
    if (!fromDate || !toDate) return { validFromDate: true, validToDate: true };  // Avoid validation if either date is not set

    let startDate = moment(fromDate).format('YYYY-MM-DD');
    let endDate = moment(toDate).format('YYYY-MM-DD');
    let startTime = startDate + " " + "00:00:00";
    let endTime = endDate + " " + "23:59:59";

    startTime = moment(startTime).format('YYYY-MM-DDTHH:mm');
    endTime = moment(endTime).format('YYYY-MM-DDTHH:mm');

    // Validate the date range
    const validFromDate = startTime < endTime;  // If FromDate is earlier than ToDate
    const validToDate = endTime > startTime;  // If ToDate is later than FromDate

    return { validFromDate, validToDate };
  }
}


// for iAgent page fixedvalue
export enum FixedValue {
  FixedValue_0 = '0',
  FixedValue_currentdate = 'current date',
  FixedValue_Multi = 'multi',
  Fixed_CPT = 'CPT',
  Fixed_PPOPOS = 'PPO/POS',
  Fixed_PPO = 'PPO',
  Fixed_POS = 'POS'
}

// for iAgent page scnario type of
export enum CheckTypeOf {
  String = 'string',
  Number = 'number',
}
